import GLightbox from 'glightbox';

(function (Drupal, once) {

  Drupal.behaviors.bendrejatLightbox = {

    attach(context) {

      once(
        'bendrejat-glightbox-gallery',
        '.views-slider-container',
        context
      ).forEach((container, index) => {

        container.querySelectorAll('.glightbox').forEach((link) => {

          const caption = link.getAttribute('data-caption');

          console.log('GLightbox link:', link);
          console.log('caption:', caption);

          link.setAttribute('data-gallery', `media-${index}`);

          if (caption) {
            link.setAttribute('data-description', caption);
          }

        });

      });

      const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: false,
        zoomable: true,
        draggable: true,
      });

      console.log('GLightbox initialized:', lightbox);

    }

  };

})(Drupal, once);